const NAMESPACE = "currentStatusCapsule";

const KEYS = {
    statusDisplayText: "statusDisplayText",
    projectOwnerText: "projectOwnerText",
    changeStatusLink: "changeStatusLink",
    viewStatusHistoryLink: "viewStatusHistoryLink",
    statusDropdownInstructionText: "statusDropdownInstructionText",
    noAvailableStatusesText: "noAvailableStatusesText",
    outsideWorkflowNoteText: "outsideWorkflowNoteText",
    outsideWorkflowWarning: "outsideWorkflowWarning",
    hasAutomationPreviewText: "hasAutomationPreviewText",
    availableInWorkflowText: "availableInWorkflowText",
    outsideNormalWorkflowText: "outsideNormalWorkflowText",
    exitingCurrentStatusMessage: "exitingCurrentStatusMessage",
    statusTransitionMessage: "statusTransitionMessage",
    enteringNewStatusMessage: "enteringNewStatusMessage",
    statusUpdateInProgressText: "statusUpdateInProgressText",
    createdOnText: "createdOnText",
    updatedOnText: "updatedOnText",
    onStatusText: "onStatusText",
    byStatusText: "byStatusText",
    currentStatusLabel: "currentStatusLabel"
};

const MESSAGES = {
    [KEYS.statusDisplayText]: {
        value: "Status marked as ",
        comment: "Text that precedes the status of the project"
    },
    [KEYS.projectOwnerText]: {
        value: "Project Owner:",
        comment: "Text that precedes Project Owner"
    },
    [KEYS.changeStatusLink]: {
        value: "Change Status",
        comment: "Text that appears in change status link"
    },
    [KEYS.viewStatusHistoryLink]: {
        value: "View Status History",
        comment: "Text that appears in view status history link"
    },
    [KEYS.statusDropdownInstructionText]: {
        value: "Select a status...",
        comment: "The instruction and top value of status dropdown"
    },
    [KEYS.noAvailableStatusesText]: {
        value: "No Status Transitions Available",
        comment: "Text that lets the user know there are no transition statuses available"
    },
    [KEYS.outsideWorkflowNoteText]: {
        value: "Note:",
        comment: "Informational text presented to user"
    },
    [KEYS.outsideWorkflowWarning]: {
        value: "This status transition is not part of the normal workflow. However, since you have the Change Status Outside Workflow privilege, you can override the workflow rules.",
        comment: "Message that lets user know they can override workflow rules"
    },
    [KEYS.hasAutomationPreviewText]: {
        value: "This status change will automatically generate and send the following communications:",
        comment: "Message that lets user know status change will generate and end an email"
    },
    [KEYS.availableInWorkflowText]: {
        value: "Available in workflow",
        comment: "Lets user know what statuses are available through workflow"
    },
    [KEYS.outsideNormalWorkflowText]: {
        value: "Outside of normal workflow",
        comment: "Lets user know what statuses are avaiable outside normal workflow"
    },
    [KEYS.exitingCurrentStatusMessage]: {
        value: "Exiting the current status:",
        comment: "Let user know leaving current status"
    },
    [KEYS.statusTransitionMessage]: {
        value: "Selected status transition:",
        comment: "Let user know status transition to"
    },
    [KEYS.enteringNewStatusMessage]: {
        value: "Entering the selected status:",
        comment: "Let user know status updated"
    },
    [KEYS.statusUpdateInProgressText]: {
        value: "Changing project status...",
        comment: "Let user know status change in progress"
    },
    [KEYS.createdOnText]: {
        value: "Created on",
        comment: "When was the project created"
    },
    [KEYS.updatedOnText]: {
        value: "Last Updated on",
        comment: "When was the project last updated"
    },
    [KEYS.onStatusText]: {
        value: " on",
        comment: "Proceeds status update date"
    },
    [KEYS.byStatusText]: {
        value: " by",
        comment: "Proceeds who did last update"
    },
    [KEYS.currentStatusLabel]: {
        value: "Current Status",
        comment: "Header for section that details projects current status"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
